export enum EChat {
  USER = 1,
  AI = 2,
}
